(function () {
  function initMarquee(root) {
    var track = root.querySelector('[data-marquee-track]');
    if (!track) return;

    var rebuild = function () {
      var originals = [];
      var child;
      var i;

      for (i = 0; i < track.children.length; i++) {
        child = track.children[i];
        if (child.getAttribute('data-marquee-clone') !== 'true') {
          originals.push(child);
        }
      }

      if (!originals.length) return;

      var clones = track.querySelectorAll('[data-marquee-clone="true"]');
      for (i = 0; i < clones.length; i++) {
        clones[i].parentNode.removeChild(clones[i]);
      }

      var setWidth = track.scrollWidth;
      if (!setWidth) return;

      var containerWidth = root.offsetWidth || window.innerWidth;
      var safety = 0;

      while (track.scrollWidth < setWidth * 2 + containerWidth && safety < 12) {
        for (i = 0; i < originals.length; i++) {
          child = originals[i].cloneNode(true);
          child.setAttribute('data-marquee-clone', 'true');
          child.setAttribute('aria-hidden', 'true');
          track.appendChild(child);
        }
        safety += 1;
      }

      track.style.setProperty('--marquee-distance', setWidth + 'px');
    };

    rebuild();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuild, 150);
    });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(rebuild, 150);
      });
      observer.observe(root);
    }
  }

  function boot() {
    var marquees = document.querySelectorAll('[data-rabitat-marquee]');
    for (var i = 0; i < marquees.length; i++) {
      initMarquee(marquees[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
